import { render, staticRenderFns } from "./hotLiveBroadcastingRoom.vue?vue&type=template&id=20e68dd0&scoped=true"
import script from "./hotLiveBroadcastingRoom.vue?vue&type=script&lang=js"
export * from "./hotLiveBroadcastingRoom.vue?vue&type=script&lang=js"
import style0 from "./hotLiveBroadcastingRoom.vue?vue&type=style&index=0&id=20e68dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e68dd0",
  null
  
)

export default component.exports